<template>
  <div class="checkout-page">
    <div class="container">
      <!-- 頁面標題 -->
      <header class="header">
        <h1>結帳頁面</h1>
        <p>請填寫您的資料以完成訂單</p>
      </header>

      <!-- 步驟指示器 -->
      <div class="steps">
        <div class="step end">
          <div class="step-number">1</div>
          <span>確認商品</span>
        </div>
        <div class="step active">
          <div class="step-number">2</div>
          <span>填寫資料</span>
        </div>
        <div class="step">
          <div class="step-number">3</div>
          <span>訂單成立</span>
        </div>
      </div>

      <!-- 主要內容區 -->
      <div class="checkout-grid">
        <!-- 左側：客戶資料表單 -->
        <div class="main-content">
          <div class="card">
            <h2>收件資料</h2>
            <form @submit.prevent="submitOrder">
              <div class="form-row">
                <div class="form-group">
                  <label for="customer-name">姓名 *</label>
                  <input
                    type="text"
                    id="customer-name"
                    v-model="orderForm.customerName"
                    disabled
                    required
                    placeholder="請輸入您的姓名"
                  />
                </div>
                <div class="form-group">
                  <label for="phone">電話 *</label>
                  <input
                    type="tel"
                    id="phone"
                    v-model="orderForm.phone"
                    disabled
                    required
                    placeholder="請輸入電話號碼"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="email">電子郵件</label>
                <input
                  type="email"
                  id="email"
                  v-model="orderForm.email"
                  disabled
                  placeholder="請輸入電子郵件（選填）"
                />
              </div>

              <!-- ✅ 地址選擇 -->
              <div class="form-group">
                <label>收件地址 *</label>

                <!-- 原本地址選項 -->
                <div v-if="userProfile.address" class="address-option">
                  <label class="radio-label">
                    <input
                      type="radio"
                      name="address-type"
                      value="original"
                      v-model="addressType"
                      @change="selectOriginalAddress"
                    />
                    <span class="radio-text">使用原本地址</span>
                  </label>
                  <div
                    v-if="addressType === 'original'"
                    class="address-display"
                  >
                    {{ userProfile.address }}
                  </div>
                </div>

                <!-- 新地址選項 -->
                <div class="address-option">
                  <label class="radio-label">
                    <input
                      type="radio"
                      name="address-type"
                      value="new"
                      v-model="addressType"
                      @change="selectNewAddress"
                    />
                    <span class="radio-text">填寫新地址</span>
                  </label>

                  <div v-if="addressType === 'new'" class="new-address-input">
                    <textarea
                      v-model="orderForm.address"
                      required
                      placeholder="請輸入完整收件地址"
                      rows="3"
                      class="address-textarea"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- 備註區塊 -->
              <div class="form-group">
                <label for="note">訂單備註</label>
                <textarea
                  id="note"
                  v-model="orderForm.note"
                  placeholder="如有特殊需求或備註，請在此填寫（選填）"
                  rows="3"
                  class="note-textarea"
                ></textarea>
                <div class="note-hint">
                  <i class="fas fa-info-circle"></i>
                  例如：配送時間要求、特殊處理說明等
                </div>
              </div>
            </form>
          </div>

          <!-- 付款方式 -->
          <!-- <div class="card">
            <h2>付款方式</h2>
            <div class="payment-method">
              <div class="payment-header">
                <h3 class="payment-title">銀行轉帳</h3>
              </div>
              <div class="bank-info">
                <div class="bank-row">
                  <span class="bank-label">銀行名稱：</span>
                  <span class="bank-value">台灣銀行</span>
                </div>
                <div class="bank-row">
                  <span class="bank-label">帳戶號碼：</span>
                  <span class="bank-value">123-456-789012</span>
                </div>
                <div class="bank-row">
                  <span class="bank-label">戶名：</span>
                  <span class="bank-value">商店名稱</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <!-- 右側：訂單摘要 -->
        <div class="sidebar">
          <div class="card">
            <h2>訂單摘要</h2>

            <!-- 商品列表 -->
            <div class="order-items">
              <div v-for="item in cartItems" :key="item.id" class="order-item">
                <!-- <img :src="item.image" :alt="item.name" />   圖片-->
                <div class="item-info">
                  <div class="item-name">{{ item.name }}</div>
                  <div class="item-quantity">數量: {{ item.quantity }}</div>
                </div>
                <div class="item-price">
                  NT$ {{ formatPrice(item.subtotal) }}
                </div>
              </div>
            </div>

            <!-- 價格計算 -->
            <div class="order-summary">
              <div class="summary-row">
                <span>商品總計：</span>
                <span>NT$ {{ formatPrice(totalAmount) }}</span>
              </div>

              <div class="summary-row total">
                <span>訂單總計：</span>
                <span>NT$ {{ formatPrice(finalAmount) }}</span>
              </div>
            </div>

            <!-- 提交訂單按鈕 -->
            <button type="submit" class="btn btn-primary" @click="submitOrder">
              提交訂單
            </button>

            <!-- 返回購物車 -->
            <button type="button" class="btn btn-secondary" @click="backToCart">
              返回購物車
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/checkout.js"  defer></script>

<style scoped src="@/assets/css/checkout.css"></style>
